// Header
export const DOCUMENT_TYPE = "documentTypeId";
export const DOCUMENT_ID = "documentId";
export const BILLING_MONTH_YEAR = "billingMonthYear";
export const BILLING_MONTH = "billingMonth";
export const BILLING_YEAR = "billingYear";
export const COMMENT = "documentHeaderText";
export const JOURNAL_ENTRY_FILE = "journalEntryFile";
export const JOURNAL_ENTRY_ID = "journalEntryId";
export const ATTACHMENT_FILE = "attachmentFile";
export const POSTING_DATE = "postingDate";
export const YEAR = "postingYear";
export const POSTING_MONTH = "postingPeriod";

// line items
export const LINE_ITEMS = "lineItems";
export const DATE = "transactionDate"; // missing
export const LINE_ITEM_TEXT = "description";
export const CHEQUE_NO = "checkNo";
export const AMOUNT = "amount";
export const DRCR = "drCr";
export const GL_ACCOUNT = "glAccountNumber"; // missing
export const SUB_LEDGER = "subledger"; // missing
export const COMBINE = "combine";
export const CUSTOMER_ACC = "customerAccountId"; // missing
export const VENDOR_ACC = "vendor";
export const PAYMENT_METHOD = "paymentMethod";
export const CLEARING = "clearing";
export const OL_REF = "oiRef";
export const OL_TOTAL = "oiTotal";

export const drcrOptions = [
  { label: "Dr", value: "DR" },
  { label: "Cr", value: "CR" },
];
